export default __webpack_public_path__ + "static/media/HISTORY_US_HISTORY.69b68e74.svg";